export enum ProzessschrittStatus {
	Neu = "NEU"
}
